import { deleteFinance, fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/output/list", {
    key: "settlement/csv",
    ...params,
  });
};

export const preSign = async (params) => {
  return await fetchFinance("/output/presign", {
    action: "get",
    ...params,
  });
};

export const createFile = async (params) => {
  return await fetchFinance("/output/file", {
    ...params,
  });
};

export const deleteFile = async (params) => {
  return await deleteFinance("/output/delete", { ...params });
};
